import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { GridRow, Grid } from '../../components/Grid/grid.js';
import { Product } from '../Product/product.js';

const ProductGroup = props => {
  const {
    item
  } = props;
  const classNames = getClassNames('llm__products');
  return jsx("div", {
    className: classNames,
    children: jsx(GridRow, {
      children: item.items.map((item, i) => jsx(Grid, {
        xs: 6,
        sm: 4,
        md: 3,
        children: jsx(Product, Object.assign({}, props, {
          item: item
        }))
      }, i))
    })
  });
};

export { ProductGroup };
//# sourceMappingURL=product-group.js.map
